import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { CategorySelect } from '../../../../Category'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { REQUEST_FORM_FIELD_NAME_CATEGORY } from '../../RequestForm.constants'

function CategoryField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={CategorySelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.CategoryPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Request.CategoryLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_FORM_FIELD_NAME_CATEGORY}
    />
  )
}

export default CategoryField
